<script setup>
import { ref, reactive, onMounted } from "vue";
import { postProjectTable } from "@/api/project";
import adjust from "./adjust.vue";

// 工程类型
const PROJECT_TYPE = [
  {
    label: "材料清单录入",
    value: "1",
  },
  {
    label: "材料退库",
    value: "2",
  },
];

// 页面title
const title = ref("工程材料管理");

// 搜索条件ref
const searchRef = ref(null);

// 详情弹窗ref
const adjustRef = ref(null);

// 搜索条件
const searchData = reactive({
  projectName: null,
  projectNumber: null,
  type: null,
});

// 表格遮罩
const tableLoading = ref(false);

// 表格列配置
const columns = ref([
  {
    label: "工程名称",
    prop: "projectName",
  },
  {
    label: "工程编号",
    prop: "projectNumber",
  },
  {
    label: "类型",
    prop: "type",
  },
  {
    label: "负责人",
    prop: "director",
  },
  {
    label: "联系方式",
    prop: "mobile",
  },
  {
    label: "审核状态",
    prop: "approvalStatus",
  },
  {
    label: "是否接收",
    prop: "status",
  },
]);

// 表格数据
const tableData = ref([]);

// 分页数据
const pages = reactive({
  page: 1,
  size: 10,
  total: 0,
});
const handleSizeChange = (val) => {
  pages.size = val;
  pages.page = 1;
  getList();
};
const handleCurrentChange = (val) => {
  pages.page = val;
  getList();
};
// 获取表格数据
const getList = () => {
  tableLoading.value = true;
  postProjectTable({
    page: pages.page,
    limit: pages.size,
    ...searchData,
  })
    .then((res) => {
      tableData.value = res.data.records;
      pages.total = res.data.total;
    })
    .finally(() => {
      tableLoading.value = false;
    });
};

// 点击重置
const searchReset = () => {
  searchRef.value.resetFields();
  pages.page = 1;
  getList();
};

// 打开详情弹窗
const openDetail = (row) => {
  adjustRef.value?.dialogOpen(row.id);
};

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #header-btn> </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item label="工程名称" prop="projectName">
          <el-input v-model="searchData.projectName" placeholder="工程名称" />
        </el-form-item>
        <el-form-item label="工程编号" prop="projectNumber">
          <el-input v-model="searchData.projectNumber" placeholder="工程编号" />
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="searchData.type" placeholder="工程类型">
            <el-option
              v-for="item in PROJECT_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="searchReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span
                v-if="['type', 'status', 'approvalStatus'].includes(item.prop)"
              >
                {{ row[item.prop].desc || "-" }}
              </span>
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" link @click="openDetail(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>

  <!-- 详情 -->
  <adjust ref="adjustRef" @after-submit="getList" />
</template>

<style lang="scss" scoped></style>
